import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';

import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';
import { getFormMapping } from '@/core/config/viewMapping/GeneralFormMapping';

import { Endpoints } from '@/api/ApiEndpoints';
@Module
export default class ChartsModule extends VuexModule {
	sales = [] as any;
	productSales = [] as any;
	clientSales = [] as any;
	salesForClient = [] as any;
	
	monthNames =["Jan","Feb","Mar","Apr",
                      "May","Jun","Jul","Aug",
                      "Sep", "Oct","Nov","Dec"];
	/**
	 * Get dynamic list object
	 *
	 */
	get getProductSales() {
		return (payload) =>{
			if(payload){
				const formatProductSales = [] as any;
				for (const key in this.productSales) {
					formatProductSales.push(this.productSales[key].productSales)
				}
			
				
				return formatProductSales;
			
			}
		}
		
	}
	get getProductLabels() {
		
		const formatProductNames = [] as any;
		for (const key in this.productSales) {
			formatProductNames.push(this.productSales[key].productName)
		}
	
		
		return formatProductNames;

	}
	
	get getSalesForClient() {
		
		const formatSales = [] as any;
	
		let lastInsertedIndex=0;
		let year = 0;
		for (const key in this.salesForClient) {
			year = this.salesForClient[key].orderYear;
			for(lastInsertedIndex; lastInsertedIndex<this.salesForClient[key].orderMonth-1;lastInsertedIndex++){
				formatSales.push({x:this.monthNames[lastInsertedIndex]+' '+this.salesForClient[key].orderYear,y:null})
			}
		
			formatSales.push({x:this.monthNames[this.salesForClient[key].orderMonth - 1]+' '+this.salesForClient[key].orderYear,y:this.salesForClient[key].commissionToPay})
			lastInsertedIndex++;
		}
		for (lastInsertedIndex; lastInsertedIndex < this.monthNames.length; lastInsertedIndex++) {
			formatSales.push({x:this.monthNames[lastInsertedIndex]+' '+year,y:null})
			
		}
		const series = [
			{
				name: "Annual Earning",
				data: formatSales,
			},
		];
		
		return series;
	
	}
	
	get getLastMonthsSales() {
		
			const month = new Date().getMonth() + 1
		
				const formatSales = [] as any;
			
				
				
				for (const key in this.sales) {
					if(this.sales[key].orderMonth> month - 2){
						formatSales.push({x:this.monthNames[this.sales[key].orderMonth - 1]+' '+this.sales[key].orderYear,y:this.sales[key].totalAmount})
					}
				}
				
				const series = [
					{
						name: 'Last months sales',
						data: formatSales,
					},
				];
				
				return series;
			
			
	}
	get getClientSales() {
		
		const formatSales = [] as any;
			
		for (const key in this.clientSales) {
			
			formatSales.push({x:this.clientSales[key].clientName,y:this.clientSales[key].totalAmount})			
		}		
		const series = [
			{
				name: "Top 5 Clients",
				data: formatSales,
			},
		];
		
		return series;					
	}

	

	@Mutation
	[Mutations.SET_SALES](sales) {
		this.sales = { ...sales };
	}
	@Mutation
	[Mutations.SET_PRODUCT_SALES](productSales) {
		this.productSales = { ...productSales };
	}
	@Mutation
	[Mutations.SET_CLIENT_SALES](clientSales) {
		this.clientSales = { ...clientSales };
	}
	@Mutation
	[Mutations.SET_SALES_FOT_CLIENT](salesForClient) {
		
		this.salesForClient = { ...salesForClient };
	}
	
	
	
}
